import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { Link, useLocation, useParams } from "react-router-dom";
import { fetchAppointmentRequests, fetchMyAppointments, fetchMyUserDetails, fetchWalletStatement, imageBaseUrl } from "../../constants/ApiConstants";
import { useSelector } from "react-redux";
import styled from "styled-components";

import toast from "react-hot-toast";
import axiosInstance from "../../utils/axiosInstance";
import { grey10, linearTopGradient, primaryColor, surfaceColor1, surfaceColor2, surfaceColor3, tuftsBlue } from "../../constants/colors";
import FullPageLoader from "../../components/FullPageLoader";
import PageHeader from "../../components/PageHeader";
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5";
import LoadMore from "../../components/LoadMore";
import { convertToK, format4DigitTimeToAmOrPM, formatDateTimeToFullDatTime, formatDateToFullDate, getAgeFromGivenDate } from "../../utils/utils";
import CommonMobileHeader from "../../components/Header/CommonMobileHeader";
import PatientAppointmentRequestCard from "../../components/PatientAppointmentRequestCard";

export default function AppointmentRequests() {
  pageTitle("Requests");
  const location = useLocation();
  const [loading, setLoading] = useState(false);

  const userId = useSelector((state) => state.appSlice.doctorData)?.id;
  const settings = useSelector((state) => state.appSlice.settings);
  const [start, setStart] = useState(0);
  const [appointments, setAppointments] = useState([]);
  const [showLoadMore, setShowLoadMore] = useState(false);

  const fetchAppointmentsFromServer = (firstLoading = true) => {
    setLoading(true);
    axiosInstance
      .post(fetchAppointmentRequests, { doctor_id: userId, count: 10, start: start })
      .then((res) => {
        if (firstLoading) {
          setAppointments(res.data.data);
          setStart(res?.data.data?.length);
        } else {
          setAppointments([...appointments, ...res?.data?.data]);
          setStart((prev) => prev + res?.data?.data?.length);
        }
        console.log({ totalAppointmentLenght: res?.data?.data });
        if (res?.data?.data?.length < 10) {
          // no more data
          setShowLoadMore(false);
        } else {
          setShowLoadMore(true);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchAppointmentsFromServer();
  }, []);

  const tabs = ["All", "Upcoming", "Completed"];
  const [selectedTab, setSelectedTab] = useState("All");

  const getFilteredAppointments = () => {
    if (selectedTab === "All") {
      return [...appointments];
    }
    if (selectedTab === "Upcoming") {
      return [...appointments.filter((item) => item.status == 1)];
    }

    return [...appointments.filter((item) => item.status == 2)];
  };

  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    const dayName = days[date.getDay()];
    return `${day} ${month}, ${year} : ${dayName}`;
  }

  return (
    <>
      <Section topMd={60} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        {loading ? (
          <FullPageLoader />
        ) : (
          <Wrapper className="content-wrapper px-3">
            <CommonMobileHeader
              title="Requests"
              trailing={
                <Link to={"/chats"} className="rounded-pill chatIconBtn">
                  <img src="/images/icons/ic_quote.png" alt="" />
                </Link>
              }
            />
            <div className="row">
              <div className="col-md-12">
                <div className="rounded px-3"></div>
                {!loading && appointments?.length === 0 && <strong className="d-block mt-5 mb-5 h-full w-full mx-auto text-gray text-center fs-md">No appointments available.</strong>}

                {!loading && appointments?.length > 0 && (
                  <div className="row pl-0 g-2 gap-2 appointmentWrapper">
                    {appointments?.map((appointment) => (
                      <PatientAppointmentRequestCard
                        key={appointment.id}
                        name={appointment.user?.fullname}
                        image={appointment.user?.profile_image}
                        dateOfBirth={appointment.user?.dob}
                        appointmentDate={appointment.date}
                        appointmentTime={appointment.time}
                        gender={appointment.user?.gender}
                        showView={true}
                        showViewHref={`/appointment-details/${appointment.id}?isDoctor=true`}
                      />
                    ))}
                  </div>
                )}
                <LoadMore
                  visible={showLoadMore}
                  loading={loading}
                  onLoadMoreClick={() => {
                    fetchAppointmentsFromServer(false);
                  }}
                />
              </div>
            </div>
          </Wrapper>
        )}
      </Section>
    </>
  );
}

const Wrapper = styled.div`
  border-radius: 12px;

  button {
    outline: none;
    border: none;
  }

  .chatIconBtn {
    background-color: ${surfaceColor3};
    border-radius: 100px;
    height: 36px;
    width: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .chatIconBtn img {
    filter: invert(14%) sepia(97%) saturate(2606%) hue-rotate(196deg) brightness(92%) contrast(98%);
    height: 20px;
  }

  @media screen and (min-width: 768px) {
  }
`;
